import React, { useMemo } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { formatPen } from "../../../../utils/finance/format";


export function FinanceCompareBarChart({
  title,
  data,
  xKey = "label",
  aKey = "a",
  bKey = "b",
  aLabel = "A",
  bLabel = "B",
}) {
  const parsed = useMemo(() => {
    if (!data) return [];
    return data.map((row) => ({
      ...row,
      [aKey]: Number(row[aKey] || 0),
      [bKey]: Number(row[bKey] || 0),
    }));
  }, [data, aKey, bKey]);

  if (!parsed.length) return null;

  return (
    <Card sx={{ borderRadius: 3, height: 360 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={parsed}>
            <XAxis dataKey={xKey} />
            <YAxis />
            <Tooltip formatter={(v) => formatPen(v)} />
            <Legend />
            <Bar dataKey={aKey} name={aLabel} />
            <Bar dataKey={bKey} name={bLabel} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
